import React from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { AppHeader } from './AppHeader';

export const Layout = ({ children }: React.PropsWithChildren) => {
  return (
    <div className="flex h-full w-full max-w-full flex-col px-2 md:w-[min(90%,1400px)] md:px-0">
      <AppHeader />
      <div className="pt-4">
        <ErrorBoundary>{children}</ErrorBoundary>
      </div>
    </div>
  );
};
